var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.26547 3.86749C8.4598 3.76149 8.6663 3.92456 8.6663 4.14592V18.8628C8.6663 19.0861 8.51438 19.2754 8.31526 19.3763C8.29844 19.3848 8.28185 19.3936 8.26547 19.4025L5.71964 20.8542C3.94297 21.8725 2.48047 21.0275 2.48047 18.9692V8.42832C2.48047 7.74582 2.96797 6.90082 3.57464 6.55415L8.26547 3.86749Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9719 6.6223C16.1422 6.70665 16.25 6.88029 16.25 7.07036V21.4118C16.25 21.7803 15.865 22.0222 15.533 21.8622L10.8455 19.6039C10.6725 19.5205 10.5625 19.3454 10.5625 19.1534V4.74893C10.5625 4.37808 10.9521 4.13629 11.2844 4.30087L15.9719 6.6223Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.833 7.03082V17.5717C23.833 18.2542 23.3455 19.0992 22.7388 19.4458L18.8941 21.6493C18.5608 21.8403 18.1455 21.5997 18.1455 21.2155V6.83364C18.1455 6.65413 18.2417 6.48839 18.3976 6.3994L20.5938 5.14582C22.3705 4.12749 23.833 4.97249 23.833 7.03082Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.3bfc4efbf8c3508721b5bd0a7604b3f4.svg";
export { ForwardRef as ReactComponent };